<div class="flex" [class.justify-end]="isCurrentUser()" [class.justify-start]="!isCurrentUser()">
  <div 
    class="max-w-[75%] rounded-xl p-3"
    [class.bg-blue-600]="isCurrentUser()"
    [class.text-white]="isCurrentUser()"
    [class.bg-gray-100]="!isCurrentUser()"
    [class.text-gray-900]="!isCurrentUser()"
  >
    <!-- User Name -->
    <div 
      class="text-xs font-semibold mb-1"
      [class.text-blue-100]="isCurrentUser()"
      [class.text-gray-500]="!isCurrentUser()"
    >
      {{ comment().userName }}
    </div>
    
    <!-- Message -->
    <div class="text-sm leading-relaxed whitespace-pre-wrap break-words">{{comment().message}}</div>
    
    <!-- Date and Edit Status -->
    <div 
      class="text-[10px] mt-1 flex items-center gap-1"
      [class.text-blue-200]="isCurrentUser()"
      [class.text-gray-400]="!isCurrentUser()"
    >
      <span>{{ comment().createdAt.toDate() | date:'short' }}</span>
      @if (isEdited()) {
        <span class="italic">(edited)</span>
      }
    </div>
  </div>
</div>
